export const Free2Pay = -1
export const Pay2Free = 1
export const BetTheSome = 0
export const FreeSpinDrainageNoModal = 0
export const FreeSpinDrainageReceiveModal = 1
export const FreeSpinDrainageGoModal = 2
